
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Nachdem sie den Winter im Stall verbracht hat, darf Erika mit sechs Monaten im Frühsommer erstmals auf die Alp. Sie darf sich nun austoben. In der Schweiz müssen laut Gesetz alle Rinder mindestens 90 Tage im Jahr Auslauf im Freien haben. Mit Erika werden in der Schweiz 270'000 weitere Kühe vom Tal zu ihren Sommerresidenzen auf Bergwiesen geführt. Und das ist eine Leistung: Im Schnitt legen Erika und ihre wandernden Artgenossen dazu auf dem Hinweg 16,3 Kilometer über oft steile Zickzackwege zurück.`}</p>
    <p>{`Erika verpflegt sich auf der Alpwiese mit verschiedenen Gräsern und Kräutern und ruht bis zu 12 Stunden pro Tag. Sie trägt so ihren Teil dazu bei, dass diese Kulturlandschaft erhalten bleibt und die Wiesen nicht zu Wald werden. Der Bund honoriert Erikas Sommeraufenthalt: Pro Kuh und Sommer (100 Tage Aufenthalt) zahlt er dem Bauern 370 Franken aus.`}</p>
    <Image file={[require('images/subventionen-02.svg'), require('images/subventionen-02.svg')]} title='Drei Beispiele von Subventionen' source='Quelle: Bundesamt für Landwirtschaft' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;